<template>
    <div class="item-box step-item" dark-class="create-page-dark" v-for="(conf, idx) in forms" :key="idx" :id="'FromItemBox-' + conf.name" :data-step-id="'StepItemBox-' + conf.name">
        <div class="item-base step-base" :class="'step-item-' + idx" v-if="getConditionValueByValue(conf.where, getScopedValue())">
            <div class="title-box">
                <p class="serial-number">{{ getStepNumber(idx) }}</p>
                <p class="name">{{ conf.title }}</p>
                <button type="button" v-if="conf.list" class="add-button" @click="onChangeList('append', conf.name)">
                    <elem-icon class="icon-box" name="add_blue"></elem-icon>
                </button>
            </div>
            <div class="step-content" v-if="conf.type === 'PASSWORD'">
                <div class="prompt">密码必须包含 1 个字母和 1 个数字，密码长度至少为 8 个字符，如需修改密码时输入任意字符或删除任意字符即可</div>
                <div class="form-box">
                    <elem-form v-for="(item, idx) in conf.data" :index="Number(idx)" :key="idx" :data="stripWhere(item)" :config="conf" :value="getRootValue()" :entityPath="entityPath" @change-data="onChangeValue"></elem-form>
                </div>
            </div>
            <div class="step-content" v-else>
                <div class="prompt" v-if="conf.prompt">{{ conf.prompt }}</div>
                <div class="form-box" v-if="!conf.list">
                    <template v-for="(item, idx) in conf.data">
                        <elem-form v-if="item.type !== 'List' && getConditionValueByValue(item.where, getScopedValue())" :index="Number(idx)" :key="idx" :data="stripWhere(item)" :config="conf" :value="getRootValue()" :entityPath="entityPath" @change-data="onChangeValue"></elem-form>
                        <elem-form-node
                            v-else-if="item.type === 'List' && getConditionValueByValue(item.where, getScopedValue())"
                            :key="'node-' + idx"
                            :forms="item.data"
                            :value="getRootValue()"
                            :rootValue="getRootValue()"
                            :entityPath="entityPath"
                            @change-data="onChangeValue"
                        ></elem-form-node>
                    </template>
                </div>
                <div class="form-box" v-else>
                    <div class="list-box" v-for="(sub, sub_idx) in getStepMap(conf)" :key="sub.key_id">
                        <template v-for="(item, idx) in conf.data">
                            <elem-form
                                v-if="item.type !== 'List' && getConditionValueByValue(item.where, getListItemValue(conf.name, sub_idx))"
                                :key="sub.key_id + '-' + idx"
                                :data="stripWhere(item)"
                                :config="conf"
                                :value="getRootValue()"
                                :entityPath="getListItemPath(conf.name, sub_idx)"
                                @change-data="onChangeValue"
                            ></elem-form>
                            <elem-form-node
                                v-else-if="item.type === 'List' && getConditionValueByValue(item.where, getListItemValue(conf.name, sub_idx))"
                                :key="sub.key_id + '-node-' + idx"
                                :forms="item.data"
                                :value="getRootValue()"
                                :rootValue="getRootValue()"
                                :entityPath="getListItemPath(conf.name, sub_idx)"
                                @change-data="onChangeValue"
                            ></elem-form-node>
                        </template>
                        <div class="operating-box">
                            <button
                                type="button"
                                class="move-button top"
                                v-show="getStepMap(conf).length > 1"
                                :disabled="Number(sub_idx) === 0"
                                @click="onChangeListSort('move-before', conf.name, Number(sub_idx))"
                            >
                                <elem-icon class="icon-box" name="arrow_bottom"></elem-icon>
                            </button>
                            <button type="button" class="clear-button" @click="onChangeList('clear', conf.name, sub_idx)">
                                <elem-icon class="icon-box" name="clear_red"></elem-icon>
                            </button>
                            <button type="button" class="add-button" @click="onChangeList('append', conf.name)">
                                <elem-icon class="icon-box" name="add_blue"></elem-icon>
                            </button>
                            <button
                                type="button"
                                class="move-button bottom"
                                v-show="getStepMap(conf).length > 1"
                                :disabled="Number(sub_idx) === getStepMap(conf).length - 1"
                                @click="onChangeListSort('move-after', conf.name, Number(sub_idx))"
                            >
                                <elem-icon class="icon-box" name="arrow_bottom"></elem-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import elemIcon from "@/components/elem-icon.vue"
import ElemForm from "@/components/elem-form.vue"

import Utils from '@/module/utils/utils';

export default {
    name: "ElemFormNode",

    components: {
        elemIcon,
        ElemForm,
    },

    data() {
        return {
            step_map: {},
            form_value: {},
        }
    },

    props: {
        forms: {
            type: Array<any>,
            default: () => [],
        },

        value: {
            type: Object,
            default: () => ({}),
        },

        // 根表单数据（用于子节点 where 同时访问根/当前节点）
        rootValue: {
            type: Object,
            default: null,
        },

        // 当前节点对应的完整路径前缀（用于生成 elem-form 的 name）
        // 例如：items[0]、items[0].carousel[1]
        entityPath: {
            type: String,
            default: "",
        },
    },

    watch: {
        value: {
            handler(value: obj) {
                const form_value = (this.form_value = value || {})
                this.initial_value = Utils.copy(form_value)
            },
            immediate: true,
            deep: true,
        },

        form_value: {
            handler(value: obj) {
                this.$emit("change-data", {
                    value
                })
            },
            deep: true,
        },
    },

    methods: {
        joinPath(base: string, segment: string): string {
            if (!base) return segment || ""
            if (!segment) return base
            return `${base}.${segment}`
        },

        getListItemPath(listName: string, idx: number | string): string {
            const base = String(this.entityPath || "")
            const prefix = this.joinPath(base, listName)
            return `${prefix}[${Number(idx)}]`
        },

        getListPath(listName: string): string {
            const base = String(this.entityPath || "")
            return this.joinPath(base, listName)
        },

        getScopedValue(): obj {
            const root = this.getRootValue()
            if (!this.entityPath) return root
            return (Utils.getStringObject(root, this.entityPath) as obj) || {}
        },

        getRootValue(): obj {
            return (this.rootValue as obj) || (this.form_value as obj) || (this.value as obj) || {}
        },

        getConditionValueByValue(where: string, scopedValue: obj) {
            if (!where) return true

            try {
                const root = this.getRootValue()
                const ctx: any = {
                    ...(root || {}),
                    ...((scopedValue as obj) || {}),
                }

                // 兼容 elem-form.vue 的 this.name（如：items[0].title）
                // where 支持写：&{a}、&{items[0].title}、&{items[0].carousel[1].url}
                ctx.__get = (path: any) => {
                    try {
                        return Utils.getStringObject(ctx, String(path ?? ""))
                    } catch (e) {
                        return null
                    }
                }

                const expr = String(where).replace(/&{([^}]+)}/g, (_m, raw) => {
                    const key = String(raw ?? "").trim()
                    return `this?.__get(${JSON.stringify(key)})`
                })

                return new Function(`return ${expr}`).call(ctx)
            } catch (e) {
                return true
            }
        },

        getConditionValue(where: string, scopedValue?: obj) {
            return this.getConditionValueByValue(where, (scopedValue as obj) || (this.form_value as obj) || (this.value as obj))
        },

        stripWhere(item: any) {
            if (!item || !item.where) return item
            return {
                ...item,
                where: null,
            }
        },


        onChangeValue(evt) {
            this.form_value = evt?.value || {}
        },

        ensureListArray(name: string): any[] {
            const root = this.getRootValue() as any
            const path = this.getListPath(name)

            let arr = Utils.getStringObject(root, path)

            if (!Array.isArray(arr)) {
                Utils.setStringObject(root, path, [])
                arr = Utils.getStringObject(root, path)
            }

            return arr as any[]
        },

        ensureListItemObject(name: string, idx: number): obj {
            const arr = this.ensureListArray(name)

            if (!arr[idx] || typeof arr[idx] !== "object") {
                // Vue3 下直接赋值即可保持响应式
                arr.splice(idx, 1, {})
            }

            return arr[idx]
        },

        getListItemValue(name: string, idx: number): obj {
            return this.ensureListItemObject(name, idx)
        },

        getStepMap(config: obj): obj[] {
            const mapKey = this.getListPath(config.name)

            if (!this.step_map[mapKey]) {
                this.step_map[mapKey] = []
            }

            const step: obj[] = this.step_map[mapKey]

            const root = this.getRootValue() as any
            const list = Utils.getStringObject(root, mapKey)

            const listLength = Array.isArray(list) ? list.length : 0
            const size = listLength > 0 ? listLength : config.required ? 1 : 0

            while (step.length < size) {
                step.push({
                    key_id: Utils.getUuid(),
                })
            }

            while (step.length > size) {
                step.splice(step.length - 1, 1)
            }

            return step
        },

        /**
         * 获取序号
         */
        getStepNumber(idx) {
            const index = Number(idx)
            const forms: any[] = this.forms || []

            let number = 0

            for (let i = 0; i <= index && i < forms.length; i++) {
                const conf = forms[i]
                if (!conf) continue
                if (this.getConditionValueByValue(conf.where, this.getScopedValue())) {
                    number++
                }
            }

            return number || index + 1
        },

        onChangeList(type: "append" | "clear", name: string, idx?: number) {
            const mapKey = this.getListPath(name)
            const step: obj[] = this.step_map[mapKey] || (this.step_map[mapKey] = [])
            const list = this.ensureListArray(name)

            if (type === "append") {
                step.push({
                    key_id: Utils.getUuid(),
                })
                list.push({})
            } else {
                step.splice(idx, 1)
                list.splice(idx, 1)
            }

            // 某些深层嵌套场景下，直接 mutate 根对象不一定能触发当前节点重渲染；
            // 强制刷新可确保新增后 move-button 立即按长度显示。
            if (typeof (this as any).$forceUpdate === "function") {
                (this as any).$forceUpdate()
            }
        },

        onChangeListSort(type: "move-after" | "move-before", name: string, idx: number) {
            const mapKey = this.getListPath(name)
            const step: obj[] = this.step_map[mapKey]
            const list = this.ensureListArray(name)

            step && Utils.each<obj>(step, (v, i) => (i === idx ? type : null))
            Utils.each<any>(list, (v, i) => (i === idx ? type : null))

            if (typeof (this as any).$forceUpdate === "function") {
                (this as any).$forceUpdate()
            }
        },
        
    },
}
</script>

<style lang="less" scoped>
@import (reference) "@/style/utils.less";
@import (reference) "@/style/color.less";

.item-box {
    padding: 30px;

    &:last-child {
        border-bottom: initial;
    }

    @media (max-width: 700px) {
        padding: 30px 0;
    }

    > .item-base {
        > .title-box {
            margin: 0 20px;
            width: 100%;

            .flex;
            .flex-center-items;

            .serial-number {
                width: 50px;
                height: 50px;
                font-size: 25px;
                color: #36414e;

                .border;
                .radius(50%);
                .flex;
                .flex-center-all;
            }

            .name {
                font-size: 25px;
                margin-left: 20px;
                color: #36414e;
            }

            .add-button {
                cursor: pointer;
                margin-left: 20px;
                width: 26px;
                height: 26px;
                padding: 0;
                background: #fff;
                border: 1px solid #e3e3e3;

                .shadow(0 0 10px rgba(0,0,0,0.1));
                .radius(50%);
                .flex;
                .flex-center-all;
                .transition;

                &:hover {
                    .shadow(0 2px 10px rgba(0,0,0,0.3));
                }

                .icon-box {
                    width: 70%;
                    height: 70%;
                }
            }
        }

        > .step-content {
            width: 100%;

            &:empty {
                display: none;
            }

            > .prompt {
                margin: 30px 20px 0 20px;
                font-size: 14px;
                max-width: 350px;
                line-height: 22px;
                letter-spacing: 1px;
                color: #888;

                p {
                    color: #888;
                }

                .title {
                    color: #333;
                }
            }

            > .form-box {
                width: 100%;
                margin-top: 20px;

                .flex;
                .flex-wrap;

                &:empty {
                    display: none;
                }

                > .list-box {
                    position: relative;
                    width: 100%;
                    padding: 20px;
                    margin-bottom: 20px;

                    .border(1px);
                    .radius(6px);
                    .flex;
                    .flex-wrap;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    > .operating-box {
                        width: 26px;

                        .flex;
                        .flex-column;
                        .flex-center-content;
                        .absolute(0, -13px, 0, initial);

                        button {
                            cursor: pointer;
                            width: 26px;
                            height: 26px;
                            margin: 5px 0;
                            padding: 0;
                            background: #fff;
                            border: 1px solid #e3e3e3;

                            .shadow(0 0 10px rgba(0,0,0,0.1));
                            .radius(50%);
                            .flex;
                            .flex-center-all;
                            .transition;

                            &:hover {
                                .shadow(0 2px 10px rgba(0,0,0,0.3));
                            }

                            .icon-box {
                                width: 70%;
                                height: 70%;
                            }
                        }

                        .add-button {
                            display: none;
                        }

                        .move-button {
                            .icon-box {
                                width: 50%;
                                height: 50%;
                            }

                            &:first-child {
                                transform: rotate(180deg);
                            }

                            &:disabled {
                                cursor: not-allowed;

                                &:hover {
                                    .shadow(0 0 10px rgba(0,0,0,0.1));
                                }

                                .icon-box {
                                    opacity: 0.2;
                                }
                            }
                        }
                    }

                    &:last-child {
                        margin-bottom: 0;

                        .operating-box {
                            .add-button {
                                .flex;
                            }
                        }
                    }
                }

                .input-error {
                    border-color: #d6626e;
                }
            }
        }
    }
}

.step-item {
    width: 100%;
}

.create-page-dark {
    border-color: #26282b;

    .item-base .title-box {
        .serial-number,
        .name {
            color: #fff;
        }

        .serial-number {
            border-color: #515574;
            background: #2c343e;
        }
    }
}
</style>
